<template>
  <div class="entry-screen">
    <div class="entry-screen__main">
      <entry-table
        ref="table"
        v-loading="optionsLoading > 0"
        class="entry-screen__table"
        :dates.sync="dates"
        :amounts.sync="amounts"
        amounts-locked
        :unit="unitName"
        :fields="actionFields"
        :values.sync="actionValues"
        skippable
        :removable="!anySent"
        :show-errors="showErrors"
        @passport="openPassport"
      ></entry-table>
    </div>
    <div class="entry-screen__actions is-plain">
      <choice-cards
        compact
        :groups="saveGroups"
        :loading="busy"
        @input="onSaveCard($event, saveDetails)"
      ></choice-cards>
    </div>
    <passport-dialog ref="passport" :type="action"></passport-dialog>
  </div>
</template>

<script>
import ChoiceCards from "@/components/ecologist/dataEntryNew/choiceCards";
import EntryTable from "@/components/ecologist/dataEntryNew/entryTable";
import PassportDialog from "@/components/ecologist/dataEntryNew/passportDialog";
import StepMixin from "./stepMixin";

// Этап полей дальнейшего действия после поступления
export default {
  name: "detailsStep",
  components: { ChoiceCards, EntryTable, PassportDialog },
  mixins: [StepMixin],

  methods: {
    saveDetails() {
      return this.withBusy("save", this.save);
    },
  },
};
</script>

<style scoped src="./entryScreen.css"></style>
